<template>
  <div class="master-container">
    <v-content>
      <v-card flat class="mx-3 mt-2 pa-2">
        <v-card-title>部品情報詳細</v-card-title>
        <v-list-item-subtitle><strong class="red--text text--lighten-1">*</strong>：必須項目</v-list-item-subtitle>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-text-field
            v-model="formData.bhn_cd"
            readonly
            disabled
          >
            <template v-slot:label>
              部品コード<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-text-field>
          <v-text-field
            v-model="formData.bhn_nm"
            :rules="mainRules"
            required
          >
            <template v-slot:label>
              部品名<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-text-field>
          <v-text-field
            v-model="formData.bbn_nm"
            :rules="Rules100"
            label="部分名"
          ></v-text-field>
          <v-text-field
            v-model="formData.bhn_info"
            label="部品情報"
            :rules="Rules100"
          ></v-text-field>
          <v-select
            v-model="formData.kki_cd"
            :items="kkiList"
            label="機械名"
            item-value="kki_cd"
            item-text="kki_nm"
            clearable
          >
            <template v-slot:label>
              機械名
            </template>
          </v-select>
          <v-text-field
            v-model="formData.kksn"
            :rules="numberRules"
            label="角寸"
          ></v-text-field>
          <v-text-field
            v-model="formData.bhn_num"
            :rules="numRules"
            label="個数"
          ><template v-slot:label>
              個数<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-text-field>
          <v-btn large color="indigo lighten-5" depressed to='/PrtsMstr/PrtsMstrKnr'>キャンセル</v-btn>
          <div class="float-right">
            <v-dialog v-model="deleteDialog" max-width="350">
              <template v-slot:activator="{ on, attrs }">
                <v-btn large color="error" v-bind="attrs" v-on="on">削除</v-btn>
              </template>
              <v-card>
                <v-card-title class="headline red lighten-4" primary-title>削除確認</v-card-title>
                <v-card-text class="pa-2">
                  部品情報を削除します。よろしいですか?<br>
                  {{formData.bhn_nm}}に紐づく以下の情報も削除されます。<br>
                  ・ 保守点検情報<br>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-text class="pa-2">
                  部品名:{{formData.bhn_nm}}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="indigo" @click="deleteDialog = false">キャンセル</v-btn>
                  <v-btn color="error" @click="submit_delete()">削除</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="updateDialog" max-width="350">
              <template v-slot:activator="{ on, attrs }">
                <v-btn large dark color="indigo" v-bind="attrs" v-on="on" @click="validate">更新</v-btn>
              </template>
              <v-card v-if="errorFlg">
                <v-card-title class="headline indigo lighten-4" primary-title>更新確認</v-card-title>
                <v-card-text>
                  <v-container>
                    <span style="white-space:pre-wrap;">{{errorMsg}}</span>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="indigo" text @click="updateDialog = false">OK</v-btn>
                </v-card-actions>
              </v-card>
              <v-card v-else>
                <v-card-title class="headline indigo lighten-4" primary-title>更新確認</v-card-title>
                <v-card-text class="pa-2">
                  部品情報を更新します。よろしいですか?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-text class="pa-2">
                  部品名:{{formData.bhn_nm}}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="indigo" @click="updateDialog = false">キャンセル</v-btn>
                  <v-btn dark color="indigo" @click="submit_update()">更新</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-form>
      </v-card>
    </v-content>
  </div>
</template>

<script>
import MstrHedr from '../../modules/MstrHedr'
import MsgList from '../../modules/MsgList'
import myAxios from '../../../axios/myAxios'

export default {
  components: {
    MstrHedr
  },
  data () {
    return {
      mainRules: [
        v => !!v || '入力は必須です',
        v => (v || '').search(' ') !== 0 || '最初に空欄を入れることは禁止です',
        v => (v || '').search('　') !== 0 || '最初に空欄を入れることは禁止です',
        v => (v && v.length <= 100) || '100文字以内で入力してください'
      ],
      Rules100: [
        v => (v || '').search(' ') !== 0 || '最初に空欄を入れることは禁止です',
        v => (v || '').search('　') !== 0 || '最初に空欄を入れることは禁止です',
        v => (v == null || v === '' || v.length <= 100) || '100文字以内で入力してください'
      ],
      numberRules: [
        v => (/^[0-9]+$/.test(v) || v == null || v === '') || '半角数字で入力してください',
        v => (v == null || v === '' || v.length <= 5) || '半角数字5文字以内で入力してください'
      ],
      numRules: [
        v => !!v || '入力は必須です',
        v => (/^[0-9]+$/.test(v) || v == null || v === '') || '半角数字で入力してください',
        v => (v == null || v === '' || v.length <= 5) || '半角数字5文字以内で入力してください'
      ],
      deleteDialog: false,
      updateDialog: false,
      dialog: false,
      userInfo: false,
      bhnNameIsValid: true,
      bhnKksnIsValid: true,
      bhnNumIsValid: true,
      bbnNameIsValid: true,
      blankIsValid: true,
      len100IsValid: true,
      isChange: false,
      errorFlg: false,
      errorMissMsg: '入力内容に間違いがあります。',
      errorMsg: '',
      formData: {
        bhn_id: '',
        bhn_cd: '',
        bhn_nm: '',
        bbn_nm: '',
        bhn_info: '',
        kiyk_cd: '',
        kki_cd: '',
        kksn: '',
        bhn_num: ''
      },
      kkiList: []
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isChange) {
      const dialog = window.confirm(MsgList.MSG_CREATE_FORM_LEAVE)
      if (dialog) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  created () {
    // ログインセッションを確認する
    myAxios.get('/api/common/session_manager', {type: 'isLogin'}).then(res => {
      const status = res.data.status
      const result = res.data.result
      myAxios.get('/api/common/session_manager', {type: 'kngn_check', url: this.$route.path}).then(res => {
        const kngnStatus = res.data.result.status
        // ログインセッションを確認できなければログイン画面に遷移する
        if (!(status && result && kngnStatus)) {
          alert(MsgList.MSG_SES_CANNOT_CONFIRM)
          this.$router.push('/')
        } else {
          this.$store.dispatch('appSetting/tLogin')
          // 入力フォームに表示するセレクトボックスの選択肢を取得
          myAxios.get('api/prts_mstr/parts_master_shinki_touroku').then(res => {
            this.kkiList = res.data.kikai_list
          })

          // 一覧からidを取得する
          var id = this.$store.getters['appSetting/selectId']

          // 部品の詳細情報を取得する
          myAxios.get('api/prts_mstr/parts_master_jouhou_shousai', {bhn_id: id}).then(res => {
            this.formData.bhn_id = id
            this.formData.bhn_cd = res.data.bhn_cd
            this.formData.kiyk_cd = res.data.kiyk_cd
            this.formData.bhn_nm = res.data.bhn_nm
            this.formData.bhn_info = res.data.bhn_info
            this.formData.bbn_nm = res.data.bbn_nm
            this.formData.kki_cd = res.data.kki_cd
            this.formData.kksn = res.data.kksn
            this.formData.bhn_num = res.data.bhn_num
          }).catch(err => {
            console.log(err)
            alert('情報取得に失敗しました')
            this.$router.push('/PrtsMstr/PrtsMstrKnr')
          })
          this.$store.dispatch('appSetting/resetId')
        }
      })
    })
  },
  methods: {
    checkBbn100 () {
      if (this.formData.bbn_nm == null || this.formData.bbn_nm === '') {
        this.formData.bbn_nm = ''
        this.bbnNameIsValid = true
      } else if (this.formData.bbn_nm.length > 100) {
        this.bbnNameIsValid = false
      } else if (this.formData.bbn_nm.search(' ') === 0) {
        this.bbnNameIsValid = false
      } else if (this.formData.bbn_nm.search('　') === 0) {
        this.bbnNameIsValid = false
      // 全て範囲内ならtrue
      } else {
        this.bbnNameIsValid = true
      }
    },
    checkInfo100 () {
      if (this.formData.bhn_info == null || this.formData.bhn_info === '') {
        this.formData.bhn_info = ''
        this.len100IsValid = true
      } else if (this.formData.bhn_info.length > 100) {
        this.len100IsValid = false
      } else if (this.formData.bhn_info.search(' ') === 0) {
        this.len100IsValid = false
      } else if (this.formData.bhn_info.search('　') === 0) {
        this.len100IsValid = false
      // 全て範囲内ならtrue
      } else {
        this.len100IsValid = true
      }
    },
    // 氏名入力チェック
    checkName () {
      // ブランクチェック
      if (!this.formData.bhn_nm) {
        this.bhnNameIsValid = false
        this.blankIsValid = false
      // 空文字チェック
      } else if (this.formData.bhn_nm.search('　') === 0) {
        this.bhnNameIsValid = false
      } else if (this.formData.bhn_nm.search(' ') === 0) {
        this.bhnNameIsValid = false
      // 文字数100チェック
      } else if (this.formData.bhn_nm.length > 100) {
        this.bhnNameIsValid = false
      } else if (this.formData.bbn_nm.length > 100) {
        this.bhnNameIsValid = false
      // 全て範囲内ならtrue
      } else {
        this.bhnNameIsValid = true
      }
    },
    checkNumber () {
      // kksnが数字のみかチェック
      if (this.formData.kksn == null || this.formData.kksn === '') {
        this.formData.kksn = null
        this.bhnKksnIsValid = true
      } else if (!/^[0-9]+$/.test(this.formData.kksn)) {
        this.bhnKksnIsValid = false
      } else if ((this.formData.kksn).indexOf(' ') > 0) {
        this.bhnKksnIsValid = false
      } else if (this.formData.kksn.length > 5) {
        this.bhnKksnIsValid = false
      } else {
        this.bhnKksnIsValid = true
      }
    },
    checkBhnNumber () {
      // bhn_numが数字のみかチェック
      if (this.formData.bhn_num == null || this.formData.bhn_num === '') {
        this.formData.bhn_num = null
        this.bhnNumIsValid = true
      } else if (!/^[0-9]+$/.test(this.formData.bhn_num)) {
        this.bhnNumIsValid = false
      } else if ((this.formData.bhn_num).indexOf(' ') > 0) {
        this.bhnNumIsValid = false
      } else if (this.formData.bhn_num.length > 5) {
        this.bhnNumIsValid = false
      } else {
        this.bhnNumIsValid = true
      }
    },
    // エラーメッセージを作成する
    makeErrorMsg () {
      this.errorMsg = ''
      // blankエラー
      if (!this.blankIsValid) {
        this.errorMsg = MsgList.MSG_FORM_INVALID
      }
      // 入力間違いエラー
      this.errorMsg = this.errorMsg + '\n' + this.errorMissMsg
      this.blankIsValid = true
    },
    validate () {
      // 機械名何も入力されていなければ空欄にする
      if (this.formData.kki_cd === null || this.formData.kki_cd === undefined) {
        this.formData.kki_cd = ''
      }
      this.checkName()
      this.checkNumber()
      this.checkBhnNumber()
      this.checkBbn100()
      this.checkInfo100()
      this.$refs.form.validate()
      // チェック項目が全て true ならば確認画面に遷移する false があればアラートを表示する
      if (this.bhnNameIsValid && this.bhnKksnIsValid && this.bbnNameIsValid && this.len100IsValid && this.bhnNumIsValid) {
        this.errorFlg = false
      } else {
        this.errorFlg = true
        this.makeErrorMsg()
      }
    },
    submit_update () {
      this.updateDialog = false
      if (this.bhnNameIsValid && this.bhnKksnIsValid) {
        // 更新ダイアログでOKを押したら更新処理
        this.isChange = false
        myAxios.post('/api/prts_mstr/parts_master_jouhou_shousai', this.formData).then(res => {
          if (res.data.status && res.data.result) {
            this.$router.push('/PrtsMstr/PrtsMstrKnr')
          } else {
            alert(MsgList.MSG_FORM_SUBMIT_ERROR)
          }
        // eslint-disable-next-line handle-callback-err
        }).catch(err => {
          alert(MsgList.MSG_FORM_SUBMIT_ERROR)
        })
      }
    },
    submit_delete () {
      this.deleteDialog = false
      // キャンセルダイアログでOKを押したら削除処理
      this.isChange = false
      myAxios.delete('/api/prts_mstr/parts_master_jouhou_shousai', {bhn_id: this.formData.bhn_id}).then(res => {
        if (res.data.status && res.data.result) {
          this.$router.push('/PrtsMstr/PrtsMstrKnr')
        } else {
          alert(MsgList.MSG_FORM_SUBMIT_ERROR)
        }
        // eslint-disable-next-line handle-callback-err
      }).catch(err => {
        alert(MsgList.MSG_FORM_SUBMIT_ERROR)
      })
    }
  },
  computed: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/templates/PrtsMstr/PrtsMstrJuhuShusi.vue